/**
 * Preset color palette for SKU labels
 * Used as defaults in get-label-color and as options in the SKU color context menu
 */
export enum SkuColorPreset {
	Green = '#90EE90',
	Pink = '#FFB6C1',
	Purple = '#CC44CC',
	Blue = '#ADD8E6',
	Orange = '#FFA500',
	Red = '#FFCCCB',
	Yellow = '#FFEB3B',
	LightYellow = '#FFFF99',
	White = '#FFFFFF',
	Gray = '#D3D3D3'
}
